import axios from 'axios';

export const PermissionsService = {
  async getPermissions({ page, perPage }) {
    const res = await axios.get('rbac/v1/permissions/', {
      params: {
        page,
        size: perPage,
      },
    });

    if (res.status === 200) {
      return res.data;
    }
    return Promise.reject();
  },

  async createPermission(data) {
    const res = await axios.post('rbac/v1/permissions/create/pg/', data);

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },

  async editPermission(data, id) {
    const res = await axios.put(`rbac/v1/permissions/${id}/`, data);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async deletePermission(id) {
    const res = await axios.delete(`rbac/v1/permissions/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
};
